import React, { useState, useEffect,useRef } from 'react';
import { createService, getService, updateServicio } from '../services/servicesService';
import './ServiceForm.css';


const ServiceForm = ({ id = null, onCreated, onUpdated, onCancel }) => {
  const titleRef = useRef(null); 
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: []
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (titleRef.current) {
          titleRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
          titleRef.current.focus();
    }
    if (id) {
      const fetchService = async () => {
        try {  
          const service = await getService(id);
          setFormData({
            title: service.title,
            description: service.description,
            image: [], // Images are not pre-filled for security/complexity reasons, user will re-upload if needed
          });
        } catch (error) {
          console.error('Error fetching service:', error);
          alert('Error al cargar el servicio para editar.');
        }
      };
      fetchService();
    } else {
      setFormData({
        title: '',
        description: '',
        image: [],
      });
    }
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: Array.from(files)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      alert('El nombre del servicio es obligatorio');
      return;
    }
    if(!formData.image.length && !id){
      alert('La imagen del servicio es obligatoria');
      return;
    }

    const data = new FormData();
    data.append('title', formData.title);
    data.append('description', formData.description);

    formData.image.forEach(img => {
      data.append('image', img); // Append as array for multiple files
    });

    try {
      setLoading(true);
      if (id) {
        await updateServicio(id, data);
        if (onUpdated) onUpdated();
      } else {
        await createService(data);
        if (onCreated) onCreated();
      }

      // Reset form if creating a new service
      if (!id) {
        setFormData({
          title: '',
          description: '',
          image: []
        });
      }

    } catch (error) {
      console.error(id ? 'Error updating service:' : 'Error creating service:', error);
      alert(id ? 'Error al actualizar el servicio' : 'Error al crear el servicio');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-form-new">
      <div className="form-header">
        <h3>{id ? 'Editar servicio' : 'Crear servicio'}</h3>
        {onCancel && (
          <button onClick={onCancel} className="btn-cancel">×</button>
        )}
      </div>

      <form onSubmit={handleSubmit} className="service-form">
        <div className="form-group">
          <label htmlFor="title">Título del servicio *</label>
          <input
            ref={titleRef}
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            required
            placeholder="Ej: Barras moviles profesionales"
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Descripción</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            required
            rows="4"
            placeholder="Describe el servicio..."
          />
        </div>

        <div className="form-group">
          <label htmlFor="image">Imágenes</label>
          <input
            type="file"
            id="image"
            name="image"
            onChange={handleFileChange}
            accept="image/*"            
          />
        </div>

        <div className="form-actions">
          {onCancel && (
            <button type="button" onClick={onCancel} className="btn-secondary">
              Cancelar
            </button>
          )}
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? (id ? 'Actualizando...' : 'Creando...') : (id ? 'Actualizar Servicio' : 'Crear Servicio')}
          </button>
        </div>
      </form>
    </div>
  );
};
export default ServiceForm;